import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ToggleItem from '../../ToggleItem';
import RadiosItem from '../../RadiosItem';
import FilterSelectItem from '../../FilterSelectItem';
import ErrorLabel from '../../../atoms/labels/ErrorLabel';
const padHour = (i = 0) => `${String(i).padStart(2, '0')}:00`;
const dayOfMonthDays = Array(31)
    .fill(0)
    .map((_, i) => ({ label: String(i + 1), value: String(i + 1) }));
const dayOfWeekDays = [
    ['1', 'monday', 'Maandag'],
    ['2', 'tuesday', 'Dinsdag'],
    ['3', 'wednesday', 'Woensdag'],
    ['4', 'thursday', 'Donderdag'],
    ['5', 'friday', 'Vrijdag'],
    ['6', 'saturday', 'Zaterdag'],
    ['7', 'sunday', 'Zondag'],
].map(([, value, label]) => ({ label, value }));
const timeOfDayHours = Array(24)
    .fill(0)
    .map((_, i) => padHour(i))
    .map(v => ({ label: `${v} uur`, value: v }));
const Frequency = ({ data, setData, errors = {}, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(RadiosItem, { data, setData }), data.frequency.period === 'monthly' && (_jsx(FilterSelectItem, { label: "Dag van de maand", required: true, options: dayOfMonthDays, name: "day_of_month", value: data.frequency.day_of_month, 
                // @ts-ignore
                error: errors['frequency.day_of_month'], setFilter: (_, value) => setData('frequency', {
                    ...data.frequency,
                    day_of_month: value,
                }) })), data.frequency.period === 'weekly' && (_jsx(FilterSelectItem, { label: "Dag van de week", required: true, options: dayOfWeekDays, name: "day_of_week", value: data.frequency.day_of_week, 
                // @ts-ignore
                error: errors['frequency.day_of_week'], setFilter: (_, value) => setData('frequency', {
                    ...data.frequency,
                    day_of_week: value,
                }) })), (data.frequency.period === 'monthly' ||
                data.frequency.period === 'weekly' ||
                data.frequency.period === 'daily') && (_jsx(FilterSelectItem, { label: "Tijdstip", required: true, options: timeOfDayHours, name: "time_of_day", value: data.frequency.time_of_day, 
                // @ts-ignore
                error: errors['frequency.time_of_day'], setFilter: (_, value) => setData('frequency', {
                    ...data.frequency,
                    time_of_day: value,
                }) })), _jsx(ToggleItem, { label: "Notificatie per e-mail ontvangen als het rapport klaar staat", checked: data.receive_notifications, onValueChange: checked => setData('receive_notifications', !checked) }), errors?.receive_notifications && (_jsx(ErrorLabel, { children: errors?.receive_notifications }))] }));
};
export default Frequency;
